import { Autocomplete, CircularProgress, FormControl, InputLabel, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import axios from "axios";
import React, { useState } from "react";

interface SelectAOEProps {
  value?: string;
  onChange: (value?: string) => void;
  name: string;
  label: string;
  id: string;
}

function AOESelect(props: SelectAOEProps) {
  const [open, setIsOpen] = useState(false);
  const { data = [], isLoading } = useQuery(
    ["AOE"],
    async () => {
      const { data } = await axios.get("field");
      return data as NnI[];
    },
    {
      staleTime: Infinity,
      refetchInterval: Infinity,
      refetchOnMount: false,
    }
  );
  const [state, setState] = useState<NnI | null>(null);

  return (
    <FormControl fullWidth variant="standard">
      <InputLabel
        sx={{
          fontSize: "1.2rem",
          mb: "0.5rem",
        }}
        htmlFor={props.id}
        shrink>
        {props.label}
      </InputLabel>
      <Autocomplete
        fullWidth
        open={open}
        onOpen={() => {
          setIsOpen(true);
        }}
        onClose={() => {
          setIsOpen(false);
        }}
        value={state}
        isOptionEqualToValue={(option, value) => option.id === value.id}
        getOptionLabel={(option) => option.name}
        options={data}
        loading={isLoading}
        onChange={(event, newValue) => {
          setState(newValue);
          props.onChange(newValue?.id);
        }}
        renderInput={(params) => (
          <TextField
            ref={params.InputProps.ref}
            {...params}
            size="medium"
            sx={[
              {
                mt: 3,
              },
            ]}
            // {...props}
            InputLabelProps={{
              // ...(params.InputLabelProps || {}),
              shrink: true,
              sx: {
                fontSize: "30px",
                marginBottom: "5rem",
                paddingBottom: "5rem",
              },
            }}
            InputProps={{
              // ...params.InputProps,
              endAdornment: (
                <React.Fragment>
                  {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                  {params.InputProps.endAdornment}
                </React.Fragment>
              ),
            }}
          />
        )}
      />
    </FormControl>
  );
}

export default AOESelect;
